/**
 * Get the router from the state.
 *
 * @function
 *
 * @param {Object} state Applications state.
 *
 * @returns {Object} The current router from state.
 */
export const getRouter = state => state.router;
